import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { productsApi } from "./Reducer/products";
import { categoryApi } from "./Reducer/category";
import { authApi } from "./Reducer/auth";
import { fileApi } from "./Reducer/file";
import { usersApi } from "./Reducer/user";
import { dashboardApi } from "./Reducer/dashboard";
import { folderApi } from "./Reducer/folder";
import { notificationApi } from "./Reducer/notification";
import {legalApi} from "./Reducer/legal";
import userReducer from "./slices/userSlice";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { bannerApi } from "./Reducer/banner";

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['user'],
};

// Create a persisted reducer for the user slice
const persistedUserReducer = persistReducer(persistConfig, userReducer);

// Create the Redux store with the persisted reducer for the user slice
export const store = configureStore({
  reducer: {
    [productsApi.reducerPath]: productsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    user: persistedUserReducer, // Use the persisted user reducer
    [categoryApi.reducerPath]: categoryApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [folderApi.reducerPath]: folderApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [bannerApi.reducerPath]: bannerApi.reducer,
    [legalApi.reducerPath]: legalApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>

    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(productsApi.middleware, authApi.middleware, categoryApi.middleware, fileApi.middleware, usersApi.middleware, dashboardApi.middleware, folderApi.middleware, notificationApi.middleware, bannerApi.middleware , legalApi.middleware),
});

// Initialize Redux Persist
export const persistor = persistStore(store);

// Setup listeners
setupListeners(store.dispatch);
